module.exports = "/images/vendor/flag-icon-css/flags/4x3/ag.svg?cce32c739dde31fdbee1e421de18aeac";